import React from "react";
import "./FAQMain.sass";
import Questions from "../Questions";
import logo from "./../../../assets/images/logo.png";
import { Link } from "react-router-dom";

export default function FAQMain() {
  return (
    <div className="FMain">
      <div className="FMain-middle-bg">
        <div className="FMain-top-bg"></div>
        <div className="FMain-container">
          <h1 className="FMain-title">FAQS</h1>
          <h2 className="FMain-subtitle">
            Ask, and it shall be given to you; seek, and you shall find
          </h2>
          <Questions />
        </div>
        <div className="FMain-bottom-bg">
          <div className="FMain-logo">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
